import axios from "axios";
import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { Pagination } from "antd";
import Spinner from "../common/Spinner";
import TrademarkItem from "../trademark/TrademarkItem";
import DesignItem from "../design/DesignItem";
import moment from "moment";
import { processJonham } from "../../helpers";
import { withRouter } from "react-router-dom/cjs/react-router-dom.min";
// import "./index.css";

const ViewData = ({ search, loading, language, view, labels, history }) => {
  const [current, setCurrent] = useState(1);
  const [marks, setMarks] = useState([]);
  const {
    introLabel,
    originLabel,
    originNameLabel,
    rDateLabel,
    rImageLabel,
    rNumberLabel,
    rOrgLabel,
    rVideoLabel,
  } = labels;

  let lang = "";
  if (language == 0) lang = "Kp";
  if (language == 1) lang = "En";
  if (language == 2) lang = "Cn";
  if (language == 3) lang = "Ru";

  const array = ["Kp", "En", "Cn", "Ru"];

  useEffect(() => {
    axios
      .get(`/api/trademark?search=${search}&language=${language}`)
      .then((res) => {
        setMarks(res.data);
      })
      .catch();
  }, [search]);

  useEffect(() => {
    if (view.type == "" && !view.data) {
      history.push("/");
    }
  }, []);

  let item;

  if (view.type == "mark") {
    item = <TrademarkItem mark={view.data} />;
  } else if (view.type == "design") {
    item = <DesignItem design={view.data} />;
  } else if (view.type == "origin") {
    item = (
      <div className="">
        <div className="origins container d-flex">
          <div className="pt-5 sidebar">
            <div
              className={
                "pointer pt-2 pt-sm-2 pt-md-3 pt-lg-4 pr-sm-1 pr-md-2 pr-lg-3 pb-3 pb-sm-3 pb-md-4 pb-lg-5 pl-4 pl-sm-4 pl-md-4 pl-lg-5 tab active"
              }
              //   onClick={() => this.handleClick(index)}
            >
              {view.data[`name${array[language]}`]}
            </div>
          </div>
          <div className="py-5 px-2 px-sm-2 px-md-3 px-lg-5 content">
            <div className="row">
              <div className="col-lg-6 col-md-12 col-sm-12">
                <img
                  src={`uploads/origin/${view.data.imageUrl}`}
                  className="border-1-red"
                  alt={view.data.imageUrl}
                  style={{ height: "200px" }}
                />
              </div>
              <div className="col-lg-6 col-md-12 col-sm-12 mt-sm-2 md-md-2">
                <div className="py-1">
                  {originNameLabel[language]} :{" "}
                  <span className="h5" style={{ color: "red" }}>
                    {view.data[`name${array[language]}`]}
                  </span>
                </div>
                <div className="py-1">
                  {originLabel[language]} :{" "}
                  {view.data[`region${array[language]}`]}
                </div>
                {/* <div className='py-1'>{categoryLabel[language]} : {data.kind}</div> */}
                <div className="py-1">
                  {rOrgLabel[language]} : {view.data.owner}
                </div>
                <div className="py-1">
                  {rNumberLabel[language]} : {view.data.regNo}
                </div>
                <div className="py-1">
                  {rDateLabel[language]} :{" "}
                  {moment(view.data.regDate).format("YYYY-MM-DD")}
                </div>
              </div>
            </div>
            <div>
              <div className="py-2 my-2 h6 border-b-1-black-3">
                {introLabel[language]}
              </div>
              <pre
                dangerouslySetInnerHTML={{
                  __html: processJonham(view.data[`desc${array[language]}`]),
                }}
              />
            </div>
            <div>
              {view.data.imageUrls.length != 0 && (
                <>
                  <div className="py-2 my-2 h6 border-b-1-black-3">
                    {rImageLabel[language]}
                  </div>
                  <div className="d-flex justify-content-start">
                    {view.data.imageUrls.slice(0, 4).map((url, index) => (
                      <img
                        key={index}
                        src={`uploads/origin/${url}`}
                        alt={url}
                        style={{ width: "23%", height: "auto" }}
                        className="mx-2"
                      ></img>
                    ))}
                  </div>
                </>
              )}
            </div>
            <div>
              {view.data.videoUrl != "" && (
                <>
                  <div className="py-2 my-2 h6 border-b-1-black-3">
                    {rVideoLabel[language]}
                  </div>
                  <div className="px-2 px-sm-2 px-md-2 px-lg-5 py-3">
                    <video width="100%" controls>
                      <source
                        src={`uploads/origin/${view.data.videoUrl}`}
                        type="video/mp4"
                      />
                      Your browser does not support HTML5 video.
                    </video>
                  </div>
                </>
              )}
            </div>
          </div>
        </div>
      </div>
    );
  }

  //   if (marks === null || marks.length === 0 || loading) {
  //     markItems = <></>;
  //   } else {
  //     if (marks.length > 0) {
  //       markItems = marks
  //         .slice((current - 1) * 4, current * 4)
  //         .map((mark) => <TrademarkItem key={mark._id} mark={mark} />);
  //     } else {
  //       markItems = <></>;
  //     }
  //   }

  return (
    <div className="trademark">
      <img className="w-100" src="./assets/trademark_banner.jpg" alt="" />
      <div className="container py-5">
        <div className="d-flex flex-column">
          {/* <p>
            {lang == "Kp" ? "자료건수:" : "Result:"}&nbsp;
            {marks ? marks.length : "0"}
          </p> */}
          <div className="d-flex flex-wrap justify-content-around">{item}</div>
        </div>
        {/* <div className="d-flex justify-content-center py-5">
          <Pagination
            defaultCurrent={1}
            total={marks.length}
            pageSize={4}
            showSizeChanger={false}
            onChange={(page) => {
              setCurrent(page);
            }}
          />
        </div> */}
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  loading: state.profile.loading,
  search: state.profile.search,
  language: state.profile.language,
  view: state.view,
  labels: state.labels,
});

export default connect(mapStateToProps, {})(withRouter(ViewData));
